<template>
  <div id="modules" style="background-color: #ffffff">
    <HeadModule :data="data" />
    <VideoDemo v-if="data.video" :data="data" />
    <br />
    <SectionsModule :data="data" />
    <br />
    <SampleModule :data="data" />
    <br />
    <WhyModule />
    <br />
    <AdvantageModule />
    <br />
    <br />
    <BtnDemoFloat />
    <!-- <hr /> -->
    <!-- <CaseOfSuccess :data="data" /> -->
  </div>
</template>
<script>
// import "particles.js";
import i18n from "@/i18n.js";
import HeadModule from "./components/Head.vue";
import SectionsModule from "./components/Sections.vue";
import SampleModule from "./components/Sample.vue";
import WhyModule from "./components/Why.vue";
import AdvantageModule from "./components/Advantage.vue";
import VideoDemo from "./components/VideoDemo.vue";
import BtnDemoFloat from "@/components/BtnDemoFloat.vue";
// import CaseOfSuccess from "./components/CaseOfSuccess.vue";
export default {
  name: "modules",
  components: {
    HeadModule,
    SectionsModule,
    SampleModule,
    WhyModule,
    AdvantageModule,
    VideoDemo,
    BtnDemoFloat,
    // CaseOfSuccess,
  },
  data() {
    return {
      title: "modules",
      locale: i18n.locale,
      blogs: {},
      mdl: null,
      data: {},
    };
  },
  mounted() {
    this.mdl = this.$route.params.name || null;
    if (this.mdl == null) {
      this.onErrorLoading();
    }
    var self = this
    this.$root.$on('changeLocale', function(locale){
      self.locale = locale
      self.loadPost();
    });

    this.loadPost();
  },
  methods: {
    onErrorLoading() {
      this.$router.push({
        path: `/`,
      });
    },
    getImgUrl(pic) {
      return require("@/assets/modules/" + pic + ".png");
    },
    async loadPost() {
      this.data = {};
      console.log("this.locale", this.locale);
      await import("@/views/modules/" + this.mdl + "/" + this.locale + ".json")
        .then((res) => {
          // console.log("-->>", res.default);
          this.data = res.default;
        })
        .catch((err) => {
          console.error(err);
          this.$buefy.toast.open({
            duration: 5000,
            message: `Module not foundt`,
            position: "is-top",
            type: "is-danger",
          });
          this.onErrorLoading();
        });
    },
  },
};
</script>
